
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '수리 시간은 얼마나 걸리나요?',
      answer: '대부분의 수리는 당일 완료됩니다. 화면 교체나 배터리 교체는 평균 1-2시간 정도 소요되며, 복잡한 수리의 경우 2-3일이 걸릴 수 있습니다. 정확한 시간은 방문 시 안내해드립니다.',
    },
    {
      question: '수리 비용은 어떻게 되나요?',
      answer: '수리 비용은 기종과 증상에 따라 다릅니다. 화면 교체는 60,000원부터, 배터리 교체는 40,000원부터 시작합니다. 정확한 견적은 기기 확인 후 안내해드립니다.',
    },
    {
      question: '수리 후 보증 기간이 있나요?',
      answer: '네, 모든 수리에 대해 3개월 보증을 제공합니다. 수리 부위에 문제가 발생할 경우 무상으로 재수리해드립니다. (고객 과실 제외)',
    },
    {
      question: '예약이 필요한가요?',
      answer: '예약 없이 방문하셔도 되지만, 대기 시간을 줄이기 위해 사전 예약을 권장합니다. 카카오톡이나 전화로 간편하게 예약하실 수 있습니다.',
    },
    {
      question: '정품 부품을 사용하나요?',
      answer: '네, 저희는 고품질의 정품 부품만을 사용합니다. 15년간의 경험을 바탕으로 검증된 부품 공급처에서만 부품을 공급받고 있습니다.',
    },
    {
      question: '데이터는 안전한가요?',
      answer: '수리 과정에서 데이터를 건드리지 않습니다. 하지만 만일의 경우를 대비해 수리 전 백업을 권장드립니다. 데이터 손실에 대한 책임은 지지 않습니다.',
    },
  ];

  return (
    <section id="faq" className="py-24 bg-[#FAFAFA]">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">자주 묻는 질문</h2>
          <p className="text-gray-600 text-base">궁금하신 점을 확인해보세요</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer"
              >
                <h3 className="text-lg font-bold text-gray-900 pr-4">{faq.question}</h3>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-[#007AFF] transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6">
                  <p className="text-gray-700 text-base leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 text-base mb-4">더 궁금하신 점이 있으신가요?</p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="inline-flex items-center gap-2 text-[#007AFF] font-medium hover:underline cursor-pointer whitespace-nowrap"
          >
            문의하기
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
